import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import { addAndApplyFilter } from '../../../actions/filterActions';
import {
    formatRange,
    parseRangeDisplayValue,
    constructCaratWeightStatsRange,
    roundCaratWeightRange,
} from '../sbSharedRefineMenuHelpers';

import { Input } from 'dibs-elements/exports/Input';
import { Button } from 'dibs-elements/exports/Button';
import ArrowRight from 'dibs-vg/dist/react/arrow-right';

// styles
import styles from '../../SbSharedRefineMenu/SbSharedRefineMenuInputRange/SbSharedRefineMenuInputRange.scss';

export class SbSharedRefineMenuCaratWeightRangeComponent extends Component {
    constructor(props) {
        super(props);

        this.onBlur = this.onBlur.bind(this);
        this.applyValue = this.applyValue.bind(this);

        this.state = {
            error: false,
            minValue: props.min,
            maxValue: props.max,
        };
    }

    componentWillReceiveProps(newProps) {
        this.validateMinMax({
            minValue: newProps.min,
            maxValue: newProps.max,
        });

        this.setState({
            minValue: newProps.min,
            maxValue: newProps.max,
        });
    }

    validateMinMax({ minValue, maxValue, shouldApply }) {
        const { applyOnBlur } = this.props;
        const error = parseInt(minValue) > parseInt(maxValue);
        if (!error && shouldApply && applyOnBlur) {
            // only apply if the value of min or max has changed
            this.props.onApply([minValue, maxValue]);
        }

        this.setState({ error });
    }

    onBlur(name, value, e) {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }

        const { availableMin, availableMax } = this.props;
        let { minValue, maxValue } = this.state;
        let shouldApply;

        if (name === 'min') {
            value =
                parseInt(value.target.value) < parseInt(availableMin)
                    ? availableMin
                    : value.target.value;
            shouldApply = value !== minValue;
            minValue = value;
            this.setState({ minValue });
        } else {
            value =
                parseInt(value.target.value) > parseInt(availableMax)
                    ? availableMax
                    : value.target.value;
            shouldApply = value !== maxValue;
            maxValue = value;
            this.setState({ maxValue });
        }

        this.validateMinMax({
            minValue,
            maxValue,
            shouldApply,
        });
    }

    applyValue(e) {
        if (e && typeof e.preventDefault === 'function') {
            e.preventDefault();
        }
        const { minValue, maxValue, error } = this.state;

        if (!error) {
            this.props.onApply([minValue, maxValue]);
        }
    }

    render() {
        const inputProps = {
            horizontalSpacing: 'small',
            size: 'large',
            showIcons: false,
            onChange: this.handleChange,
            hasError: this.state.error,
            maxLength: 17,
        };

        return (
            <div>
                <div className={styles.container}>
                    <Input
                        name="carat-weight-min"
                        onBlur={(value, e) => this.onBlur('min', value, e)}
                        value={this.state.minValue.toString()}
                        dataTn={'search-browse-carat-weight-input-min'}
                        {...inputProps}
                    />
                    <div className={styles.divider}>
                        <FormattedMessage
                            id="sb.SbSharedRefineMenuCaratWeight.inputRange.to"
                            defaultMessage="to"
                        />
                    </div>
                    <Input
                        name="carat-weight-max"
                        onBlur={(value, e) => this.onBlur('max', value, e)}
                        value={this.state.maxValue.toString()}
                        dataTn={'search-browse-carat-weight-input-max'}
                        {...inputProps}
                    />
                    {!this.props.applyOnBlur && (
                        <Button
                            size="large"
                            type="secondary"
                            onClick={this.applyValue}
                            className={styles.inputRangeButton}
                            dataTn={'search-browse-carat-weight-apply'}
                        >
                            <ArrowRight className={styles.arrow} />
                        </Button>
                    )}
                </div>
                {this.state.error && (
                    <div className={styles.error}>
                        <FormattedMessage
                            id="sb.SbSharedRefineMenuCaratWeight.inputRange.error"
                            defaultMessage="Min value may not exceed max"
                        />
                    </div>
                )}
            </div>
        );
    }
}

SbSharedRefineMenuCaratWeightRangeComponent.defaultProps = {
    onApply: () => {},
    hasError: false,
    applyOnBlur: false,
};

SbSharedRefineMenuCaratWeightRangeComponent.propTypes = {
    onApply: PropTypes.func,
    applyOnBlur: PropTypes.bool,
    min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    availableMin: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    availableMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

function mapStateToProps(state, props) {
    const availableDisplayValue = get(props, 'filter.values[0].urlLabel');
    const appliedDisplayValue = get(props, 'values[0].urlLabel') || '';

    const [min, max] = constructCaratWeightStatsRange(appliedDisplayValue, availableDisplayValue);
    const [parsedMin, parsedMax] = parseRangeDisplayValue(availableDisplayValue);
    const [availableMin, availableMax] = roundCaratWeightRange(parsedMin, parsedMax);

    return { min, max, availableMin, availableMax };
}

function mapDispatchToProps(dispatch, props) {
    return {
        onApply(minMax) {
            dispatch(addAndApplyFilter(props.filter.name, formatRange(minMax)));
        },
    };
}

export const SbSharedRefineMenuCaratWeightRange = connect(
    mapStateToProps,
    mapDispatchToProps
)(SbSharedRefineMenuCaratWeightRangeComponent);
